import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
} from '@angular/core';

@Component({
  selector: 'app-iberoplast-chat',
  templateUrl: './iberoplast-chat.component.html',
  styleUrls: ['./iberoplast-chat.component.css'],
})
export class IberoplastChatComponent implements AfterViewInit, OnDestroy {
  private readonly containerId = 'iberoplast-chat-target';
  private readonly styleUrl =
    'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/style.css';
  private readonly bundleUrl =
    'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';
  private readonly webhookUrl =
    'https://alys-n8n-iberoplast.eastus2.azurecontainer.io/webhook/c32f7d85-ff07-4649-9b1b-c76885dbe605/chat';

  constructor(private readonly host: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const hostEl = this.host.nativeElement;
    if (hostEl.parentElement !== document.body) {
      document.body.appendChild(hostEl);
    }

    const targetEl = document.getElementById(this.containerId);
    if (!targetEl) return;

    targetEl.innerHTML = '';

    if (!document.querySelector(`link[href="${this.styleUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = this.styleUrl;
      document.head.appendChild(link);
    }

    const existingScript = document.getElementById(
      'iberoplast-chat-module-script'
    );
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }

    const initialMessages = [
      '¡Hola! 👋 Soy ALYS. ¿En qué puedo ayudarte hoy?',
    ];

    const script = document.createElement('script');
    script.id = 'iberoplast-chat-module-script';
    script.type = 'module';
    script.textContent = `
      import { createChat } from '${this.bundleUrl}';
      createChat({
        webhookUrl: ${JSON.stringify(this.webhookUrl)},
        webhookConfig: { method: 'POST' },
        showWelcomeScreen: true,
        title: 'ALYS - Inteligencia Industrial',
        subtitle: 'Soporte Iberoplast',
        mainColor: '#3B82F6',
        target: '#${this.containerId}',
        mode: 'window',
        initialMessages: ${JSON.stringify(initialMessages)},
        i18n: {
          en: {
            placeholder: 'Escribe tu consulta...',
            sendButtonText: 'Enviar'
          }
        }
      });
    `;

    document.body.appendChild(script);
  }

  ngOnDestroy(): void {
    const moduleScript = document.getElementById(
      'iberoplast-chat-module-script'
    );
    if (moduleScript && moduleScript.parentNode) {
      moduleScript.parentNode.removeChild(moduleScript);
    }
    const target = document.getElementById(this.containerId);
    if (target) {
      target.innerHTML = '';
    }
  }
}

